import React, { useReducer } from "react";
// import "./HeaderItemStyle.css";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import {initialState, reducer} from "../Reduceres/reducer";
import { NEXT_PAGE, PREV_PAGE,  GO_TO_PAGE} from "../Reduceres/Action";

const Pagination = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const handlePageChange = (pageNumber) => {
    dispatch({ type: GO_TO_PAGE, payload: pageNumber });
  };

  const goToNextPage = () => {
    dispatch({ type: NEXT_PAGE });
  };

  const goToPrevPage = () => {
    dispatch({ type: PREV_PAGE });
  };

  return (
    <div className="paginationContainer">
      <GrFormPrevious onClick={goToPrevPage} disabled={state.currentPage === 1} />
      {[...Array(state.totalPages)].map((_, index) => (
        <button key={index} onClick={() => handlePageChange(index + 1)} className="numbring">{index + 1}</button>
      ))}
      <GrFormNext onClick={goToNextPage} disabled={state.currentPage === state.totalPages} />
    </div>
  );
};

export default Pagination;
